module.exports = __webpack_public_path__ + "img/icon-CREATED.336f8d29.png";